import React from 'react'
import Layout from '../components/layout'

const error = () => {
    
    return (
      <Layout>
          <div>404 Page cannot be found</div>
      </Layout>
    )
}
export default error